export enum BOOK_WIDGET_ERROR_CODES {
  AEM_FAILURE = 'SBW001',
  DEFAULT_LOOKUP_FAILURE = 'SBW002',
  GEO_LOCATION_FAILURE = 'SBW003',
  LOGIN_DASHBOARD_FAILURE = 'SBW004',
  MC_RETRIEVE_SEARCH_FAILURE = 'SBW005',
  OW_RT_RETRIEVE_SEARCH_FAILURE = 'SBW006',
  CATALOG_FAILURE = 'SBW007',
  BOOK_FIELD_ERROR_MISSING_DATE = 'SBW008',
  BOOK_FIELD_ERROR_MISSING_DATES = 'SBW009',
  BOOK_FIELD_ERROR_INVALID_DATE = 'SBW010',
  BOOK_FIELD_ERROR_MISSING_DESTINATION = 'SBW011',
  BOOK_FIELD_ERROR_MISSING_ORIGIN = 'SBW012',
  BOOK_FIELD_ERROR_MISSING_ORIGIN_DESTINATION = 'SBW013',
  BOOK_FIELD_ERROR_SAME_ORIGIN_DESTINATION = 'SBW014',
  BOOK_FIELD_ERROR_INVALID_AIRPORT = 'SBW015',
  BOOK_FIELD_ERROR_INVALID_CONNECTION_AIRPORT = 'SBW016',
  BOOK_FIELD_ERROR_INVALID_MEETING_CODE = 'SBW017',
  BOOK_FIELD_ERROR_GLOBAL_ERROR = 'SBW018',
  SAVED_SEARCH_FAILURE = 'SBW019',
  UPDATE_SEARCH_API_ERROR = 'SBW020',
  UPDATE_SEARCH_PAYLOAD_ERROR = 'SBW021',
  PREDICTIVE_SEARCH_AWS_BFF_API = 'SBW022',
  SLIM_NAV_MULTICITY_PAYLOAD_ERROR = 'SBW023',
  NO_AUTH_TOKEN_BUT_USER_LOGGED_IN = 'SBW024',
  MAKING_TOKEN_NULL_AFTER_30_MINS = 'SBW025'
}

export const BookWidgetMetaDataName = 'shoppingBookWidgetErrorCodes';
